import type { NodeEffect } from "@/document/model/styles";
import type { EffectType } from "./paintStyles";

export const effectOptions: Array<{ type: EffectType; label: string }> = [
  { type: "dropShadow", label: "Drop shadow" },
  { type: "innerShadow", label: "Inner shadow" },
  { type: "layerBlur", label: "Layer blur" },
  { type: "backgroundBlur", label: "Background blur" },
];

export function effectTypeLabel(type: EffectType): string {
  return effectOptions.find(option => option.type === type)?.label ?? type;
}

export function effectSummary(effect: NodeEffect): string {
  switch (effect.type) {
    case "dropShadow":
    case "innerShadow":
      return `${effect.offsetX}, ${effect.offsetY} · Blur ${effect.blur}`;
    case "layerBlur":
      return effect.mode === "uniform" ? `Blur ${effect.blur}` : `${effect.start} → ${effect.end}`;
    case "backgroundBlur":
      return `Blur ${effect.blur}`;
  }
}
